import React from 'react';
import PropTypes from 'prop-types';
import { styled } from 'twin.macro';

const StyledLink = styled.a`
  color: ${({ theme }) => theme.black};
`;

const NotificationWrapper = ({ link, children }) => {
  if (link) {
    return (
      <StyledLink rel="noreferrer" href={link} target="_blank">
        {children}
      </StyledLink>
    );
  }

  return <div>{children}</div>;
};

NotificationWrapper.propTypes = {
  link: PropTypes.string
};

export default NotificationWrapper;
